import React, { ReactNode } from "react";
import styled from "styled-components";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

interface AccountButtonProps extends React.PropsWithChildren {
  id?: string;
  type?: "button" | "submit" | "reset";
  disabled: boolean;
  onClick: () => void;
  title: string;
  icon: string;
}
const AccountButton: React.FC<AccountButtonProps> = ({
  id,
  type,
  disabled,
  onClick,
  title,
  icon,
}) => {
  return (
    <AccountButtonStyle type={type} disabled={disabled} onClick={onClick}>
      <div>
        <span> {title}</span>
        <img src={icon} alt={title} />
      </div>
    </AccountButtonStyle>
  );
};

export default AccountButton;

export const AccountButtonStyle = styled.button`
  padding: 10px 16px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold1};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  white-space: nowrap;
  color: ${({ disabled }) => (disabled ? "#afafaf" : "#0e0e0e")};
  border-radius: 10px;
  border: 1px solid #e8eaed;
  background-color: transparent;
  box-shadow: 0px 4px 4px 0px #eaeaea40;

  div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    @media screen and (max-width: 767px) {
      justify-content: center;
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;
  }
  img {
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  }
`;
